import type { Context } from 'react';
import { createContext, useContext } from 'react';

import type { Theme } from '../../util/theme/fluent9';
import { webLightTheme } from '../../util/theme/fluent9';

export interface AppContainerFUI9ThemePrivateContextProviderProps {
  readonly theme: Theme;
  readonly dir: 'ltr' | 'rtl';
}
export const AppContainerFUI9ThemePrivateContext: Context<AppContainerFUI9ThemePrivateContextProviderProps> =
  createContext<AppContainerFUI9ThemePrivateContextProviderProps>({
    theme: webLightTheme,
    dir: 'ltr',
  });

export const useAppContainerFUI9ThemePrivateContext = (): AppContainerFUI9ThemePrivateContextProviderProps =>
  useContext(AppContainerFUI9ThemePrivateContext);
